import { record } from "fp-ts";
import { pipe } from "fp-ts/lib/function";

const citiesList = require("./cities.json") as Cities;

/**
 * B = Brussels Hoofdstedelijk Gewest
 * W = Waals Gewest
 * V = Vlaams Gewest, (Flanders)
 */
export type Gewest = "B" | "W" | "V";
export interface City {
  name: {
    nl: string;
    fr: string;
  };
  taxRate: number;
  gewest: Gewest;
}
interface Cities {
  [zipCode: string]: City;
}

const tryFind = (zipCode: string) => pipe(citiesList, record.lookup(zipCode));

export const cities = {
  tryFind,
};
